import styled from 'styled-components';
import Container from 'components/Container';

const TimelineContainer = styled(Container)`
  @media (min-width: 640px) {
    padding-left: 8rem;
  }
`;

export default TimelineContainer;
